import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import rootReducer from './redux/reducers';

// Configuration of redux persist
const persistConfig = {
  key: 'store',
  storage,
  whitelist: ['loginReducers', 'userProfileReducers', 'lightModeReducers'],
};

// Persisting reducers
const persistedReducer = persistReducer(persistConfig, rootReducer);
const composedEnhancer = compose(
  applyMiddleware(thunk),
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f
);
export const store = createStore(
  persistedReducer,
  // eslint-disable-next-line no-underscore-dangle
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  composedEnhancer
);


// Persisting store
export const persistor = persistStore(store);

export default store;
